import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingKycPersonalSubmittedProps = EventProps

/**
 * @event onboarding_kyc_personal_submitted
 * @description Emitted when the user completes the FrankieOne KYC personal details screen and advances to document upload.
 */
export const OnboardingKycPersonalSubmittedAnalytics = createAnalyticsStatic<OnboardingKycPersonalSubmittedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_KYC_PERSONAL_SUBMITTED,
)

export default OnboardingKycPersonalSubmittedAnalytics
